import React from 'react'
import { provideState, injectState } from 'freactal'
import { Switch, Route } from 'react-router-dom'
import { Tooltip, Icon } from 'react-mdl'
import styled from 'styled-components'

import UnitContent from './UnitContent'
import SectionContent from './SectionContent'
import MappingTable from './MappingTable'
import SectionMapping from './SectionContent/SectionMapping'

const Container = styled.div`
  width: 100%;
`
const Content = styled.div`
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: space-between;
`
const Item = styled.div`
  width: 50%;
`

const withState = provideState({})

export default withState(injectState(LearnerGuide))

function LearnerGuide({ state: { unit } }) {
  return (
    <Switch>
      <Route
        path="/units/:unitId/learner-guide/:sectionIndex(\d\.\d+)"
        component={SectionContent}
      />
      <Route
        render={() => (
          <Container>
            <Route
              exact
              path={
                '/units/:unitId/learner-guide/section-mapping/:sectionIndex'
              }
              component={SectionMapping}
            />
            <h3>
              Learner Guide Content{' '}
              <Tooltip label="It will take longer to save the new shape of the unit when there is content in the sections.">
                <Icon name="information" />
              </Tooltip>
            </h3>
            <Content>
              <Item>
                <UnitContent unit={unit} />
              </Item>
              <Item>
                <MappingTable unit={unit} />
              </Item>
            </Content>
          </Container>
        )}
      />
    </Switch>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/index.js